export const deadlines = (state) => state.deadlines
export const totalDeadlines = (state) => state.totalDeadlines

export const getDeadlineById = (state) => (id) => {
  return state.deadlines.find(deadline => deadline.id === id)
}